import React from 'react'
import { Modal, Grid } from 'semantic-ui-react'


import { useTranslation } from 'react-i18next'
import ModalWithCatastrophicFailureErrorBoundary from '../../../../../../../common-components/semanticUiCustomComponents/componentsWithCatastrophicFailureErrorBoundary/ModalWithCatastrophicFailureErrorBoundary'
import TextAsPseudoLink from '../../../../../../../common-components/TextAsPseudoLink'

import {
  getInfoDefinitionsInboundEmptyKegShipmentFullDetails,
} from '../../../../util/shipmentHistory/inboundEmptyKegShipmentHistory'

import HistoryLabelWithContainerTypesDifferencesPopupIfNecessary from '../../../../util/HistoryLabelWithContainerTypesDifferencesPopupIfNecessary'
import DownLoadPaperwork from './DownloadPaperwork'

export default ({
  entireItemSkusSlice,
  entireSubsidiariesSlice,
  customerId,
  subsidiaryId,
  info: shipmentDetails,
  itemSkuIdsToIncludeAsFieldsInTable,
  entireCustomersSlice,
}) => {
  const { t: translate } = useTranslation('common')
  return (
    <ModalWithCatastrophicFailureErrorBoundary // CODE_COMMENTS_131
      closeIcon
      size="large"
      trigger={<TextAsPseudoLink>{shipmentDetails.shipmentId}</TextAsPseudoLink>}
      className="test-full-shipment-details"
    >
      <Modal.Header>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span>{translate('Shipment Details')}</span>
        <div>
          <DownLoadPaperwork podS3Key={shipmentDetails?.proofOfDeliveryS3Key} />
        </div>
      </div>
      </Modal.Header>
      <Modal.Content>
        <AdditionalShipmentDetails
          entireItemSkusSlice={entireItemSkusSlice}
          entireSubsidiariesSlice={entireSubsidiariesSlice}
          customerId={customerId}
          subsidiaryId={subsidiaryId}
          shipmentDetails={shipmentDetails}
          itemSkuIdsToIncludeAsFieldsInTable={itemSkuIdsToIncludeAsFieldsInTable}
          entireCustomersSlice={entireCustomersSlice}
        />
      </Modal.Content>
    </ModalWithCatastrophicFailureErrorBoundary>
  )
}

const AdditionalShipmentDetails = ({
  entireItemSkusSlice,
  entireSubsidiariesSlice,
  customerId,
  subsidiaryId,
  shipmentDetails,
  itemSkuIdsToIncludeAsFieldsInTable,
  entireCustomersSlice,
}) => {
  const toDisplay = getInfoDefinitionsInboundEmptyKegShipmentFullDetails({
    entireItemSkusSlice,
    entireSubsidiariesSlice,
    subsidiaryId,
    itemSkuIdsToIncludeAsFieldsInTable,
    customerId,
    entireCustomersSlice,
  })

  const rowElements = [] // React 16-style array of React elements

  toDisplay.forEach(definition => {
    if (!definition.displayCondition || definition.displayCondition(shipmentDetails)) {
      rowElements.push(
        <Grid.Row key={definition.heading} className="compact-grid-row">
          <Grid.Column width={3} style={{ fontWeight: 'bold' }}>
            <HistoryLabelWithContainerTypesDifferencesPopupIfNecessary
              customerId={customerId}
              labelText={definition.heading}
              colonAfterText
            />
          </Grid.Column>
          <Grid.Column width={13}>{definition.cellContent(shipmentDetails)}</Grid.Column>
        </Grid.Row>,
      )
    }
  })

  return (
    // For alignment purposes, all displayed content within this grid needs to
    // be contained within a <Grid.Column> component; see CODE_COMMENTS_97 for
    // why.
    <Grid columns={2}>
      {rowElements}
    </Grid>
  )
}
